import { render, staticRenderFns } from "./MauticSubscribe.vue?vue&type=template&id=97e54468&lang=pug&"
import script from "./MauticSubscribe.vue?vue&type=script&lang=js&"
export * from "./MauticSubscribe.vue?vue&type=script&lang=js&"
import style0 from "./MauticSubscribe.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports